import { useState } from "react";
import { createMediator } from "@/shared/lib/componentHierarchy";
import {
  useComponentNode,
  useHierarchyLifetime,
} from "@/shared/ui/component-hierarchy/hooks";
export function useErrorFallbackPresenter(): () => void {
  const [mediator] = useState(() =>
    createMediator<boolean, { type: "app.reload" }, "reload">(
      false,
      (state) => ({
        status: "handled",
        state: true,
        effects: state ? [] : ["reload"],
      }),
      { runEffect: () => window.location.reload() },
    ),
  );
  useHierarchyLifetime(mediator);
  const node = useComponentNode((event) => {
    if (event.type !== "app.reload") return "unhandled";
    mediator.dispatch({ type: "app.reload" });
    return "handled";
  });
  return (): void => {
    node.dispatch({ type: "app.reload" });
  };
}
